<template>
  <div>
    <div
      :class="[
        'panel',
        { 'panel--active': navBarMobileVisible },
        { 'new-sidebar': showNewSidebar },
      ]"
    >
      <dashboard-new-sidenav v-if="showNewSidebar">
        <slot slot name="sidenav-content">
          Default sidenav
        </slot>
      </dashboard-new-sidenav>
      <dashboard-sidenav v-if="!showNewSidebar">
        <slot slot name="sidenav-content">
          Default sidenav
        </slot>
      </dashboard-sidenav>
      <div class="panel-content">
        <slot name="content"></slot>
        <page-footer />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DashboardNewSidenav from './SidenavNew.vue'
import DashboardSidenav from './Sidenav.vue'

export default {
  props: {
    showNewSidebar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DashboardNewSidenav,
    DashboardSidenav,
  },
  computed: {
    ...mapState({
      navBarMobileVisible: (state) => state.common.navBarMobileVisible,
    }),
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

@media screen and (max-width: 768px) {
  .panel {
    background: none;

    & .panel-content {
      margin-left: initial;
    }
  }

  .panel--active {
    background: $grey30;
  }
}
</style>
